import {useMemo} from 'react';
import ADSButton from "../../../../../ADSButton";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import {useADSContext} from "../../../../../../context/ADSProvider";
import {useAIToolsContext} from "../../../../../../context/AIToolsProvider";
import {AITools} from "../../../../../../constant";
import {useImageEditorContext} from "../../../../../../context/ImageEditorProvider";

const ADSGenerate = () => {
  const {form, formHasChanged, selectedProduct, userInfo, handleGenerateProduct, handleRegenerateProduct} = useADSContext();
  const {selectedAITools, firstSelectedImage, firstSelectedImageServerPath, firstBoundingBoxSelectedIndexes, secondBoundingBoxSelectedIndexes, canvasHasChanges, selectedAvatarStrengthIndex} = useAIToolsContext();
  const {isEditingImage} = useImageEditorContext();

  const disabled = useMemo(() => {
    const {balance} = userInfo.userCredit || {};
    const {model, prompt} = form

    if (isEditingImage) {
      return true
    }

    // allow regenerate feature
    if (!formHasChanged && !selectedAITools && selectedProduct?.id) {
      return !balance
    }

    switch (selectedAITools) {
      case AITools.SwapFace: {
        return !balance || !model || !firstBoundingBoxSelectedIndexes || !secondBoundingBoxSelectedIndexes
      }

      case AITools.FaceCorrection: {
        return !balance || !model || !firstBoundingBoxSelectedIndexes
      }

      case AITools.AvatarConverter: {
        return !balance || (!firstSelectedImage && !firstSelectedImageServerPath) || !selectedAvatarStrengthIndex;
      }

      case AITools.RemoveBackground:
      case AITools.BlurBackground:{
        return !balance || !model;
      }

      case AITools.HighlightAndRemove: {
        return !balance || !model || !canvasHasChanges
      }

      case AITools.HighlightAndSwap:
      case AITools.HighlightAndSwap2: {
        return !balance || !model || !prompt || !canvasHasChanges;
      }

      default:{
        return !balance || !model || !prompt
      }
    }
  }, [canvasHasChanges, firstBoundingBoxSelectedIndexes, firstSelectedImage, firstSelectedImageServerPath, form, formHasChanged, isEditingImage, secondBoundingBoxSelectedIndexes, selectedAITools, selectedAvatarStrengthIndex, selectedProduct?.id, userInfo.userCredit])

  const showGenerate = formHasChanged || !selectedProduct?.id

  return (
    <ADSButton
      onClick={showGenerate ? handleGenerateProduct : handleRegenerateProduct}
      disabled={disabled}
      style={{height: 48, width: 192}}
    >
      <AutoAwesomeIcon style={{width: 20, height: 20}} />
      {showGenerate ? 'Generate' : 'Re-Generate'}
    </ADSButton>
  );
};

export default ADSGenerate;
